import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { ListGroup } from "react-bootstrap";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <ListGroup variant="flush">
          <ListGroup.Item style={{ background: "none" }}>
            <Button variant="primary" href={props.link} target="_blank">
              GitHub
            </Button></ListGroup.Item>
          <ListGroup.Item style={{background: "none"}}>
            <Button variant="primary" href={props.deploy} target="_blank">
              Open Site
            </Button>
          </ListGroup.Item>
          <ListGroup.Item style={{ background: "none" }}>
             <Button variant="primary" href={props.bloglink} target="_blank">
              Open Blog
            </Button>
          </ListGroup.Item>
        </ListGroup>
        
        
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
